// extracted by mini-css-extract-plugin
export default {"whatsappBtnWrapper":"WhatsappButton_whatsappBtnWrapper__4rUiM","whatsappBtn":"WhatsappButton_whatsappBtn__QlEVu","whatsappWiggle":"WhatsappButton_whatsappWiggle__-U12e"};